import { useNavigation } from '#app/hooks/useNavigation.js';
import { logger } from '#app/services/logger.js';
import { useMount } from '@contra/react-hooks/useMount';
import { captureException } from '@contra/sentry/react';

const log = logger.child({
  namespace: 'ExternalRedirect',
});

type RedirectProps = {
  readonly action?: 'open' | 'push' | 'replace';
  readonly href: string;
};

export const ExternalRedirect = ({
  action = 'replace',
  href,
}: RedirectProps) => {
  const navigation = useNavigation();

  useMount(() => {
    let url: null | URL = null;
    try {
      url = new URL(href);
    } catch (error) {
      log.error(
        {
          href,
        },
        'Attempted to redirect externally to invalid URL',
      );
      captureException(error);
      throw error;
    }

    switch (action) {
      case 'open':
        window.open(url.toString(), '_blank');
        break;
      case 'push':
        navigation.push(url.toString());
        break;
      case 'replace':
        navigation.replace(url.toString());
        break;
      default:
        log.error(
          {
            action,
          },
          'Attempted to redirect externally with invalid action',
        );
        break;
    }
  });

  return null;
};
